import { useLocation, useNavigate } from "react-router-dom"
import { ESMCommunityPlanScreen } from "../../screen/ESMCommunityPlanScreen"
import { useEffect, useState } from "react"
import { customToast } from "../../components/Toast";
import { sort } from "fast-sort";
import { useScope } from "../SelectProjectCompanyContainer";
import Send from "../../core/communication";

const loadActions = async (indicatorId, userId, scopeId, scopeType) => {
  let newActions = [];

  if(userId) {
    newActions = await Send.get(`/scale-action-producer/indicator/${indicatorId}/${userId}`)
    .catch(() => []);
  } else if(scopeId) {
    newActions = await Send.get(`/scale-action-project/indicator/${indicatorId}/${scopeId}`, `scopeType=${scopeType}`)
    .catch(() => []);
  }

  const indicatorActions = await Send.get(`/scale-action/indicator/${indicatorId}`)
  .catch(() => []);

  return { indicatorActions, newActions };
}

const ESMCommunityPlanContainer = () => {
  const { scope, scopeType } = useScope();
  const navigate = useNavigate()
  const location = useLocation()
  const props = location.state
  const [reload, setReload] = useState(true);
  const [indicatorActions, setIndicatorActions] = useState([])
  const [actions, setActions] = useState([])
  const [showModalActions, setShowModalActions] = useState(false);

  console.log("STRER", location.state)

  const handleChangeIsComplete = async (scaleActionProId, currentActionIsComplete, isCommunity) => {
    if(!currentActionIsComplete) {
      let response;
      if(!isCommunity) {
        response = await Send.put(`/scale-action-producer/${scaleActionProId}`, {
          isComplete: new Date()
        })
      } else {
        response = await Send.put(`/scale-action-project/${scaleActionProId}`, {
          isComplete: new Date()
        })
      }
  
      if(response && response.id) {
        customToast('Ação marcada como concluída', 'success');
        setReload(true)
        return;
      }
  
      customToast('Erro ao completar ação', 'error');
      return;
    }
  }
  
  const formatActionsByODS = (actions, isCommunity) => {
    if(!actions || !actions.length) {
      return [];
    }
  
    return Array.isArray(actions) ? sort(actions).desc('createdAt').map((item) => {
      return {
        ...item,
        ...item.action,
        actionProducer: item.id,
        ods: 1,
        area: item?.action?.area || "",
        indicator: item?.indicator?.title || "",
        level: item?.action?.level || "Alto",
        handleChangeIsComplete: () => handleChangeIsComplete(item.id, item.action?.isComplete, isCommunity) // 
      }
    }) : []
  }

  const goBack = () => {
    navigate(-1 || "/")
  }

  useEffect(() => {
    if(props?.scaleIndicatorId && reload) {
      loadActions(props?.scaleIndicatorId?.id || props?.scaleIndicatorId, props?.userId, scope?.id, scopeType)
      .then(({indicatorActions, newActions}) => {
        setIndicatorActions(indicatorActions);
        setActions(newActions);
      })
      .catch(error => {
        console.log("ERROR", error);
        customToast('Falha ao carregar ações', 'error');
      });

      setReload(false);
    }
  }, [props, reload])

  const handleOpenActionsModal = () => {
    setShowModalActions(true);
  }

  const handleCloseActionsModal = () => {
    setReload(true);
    setShowModalActions(false)
  }

  return (
    <div>
      <ESMCommunityPlanScreen
        {...{
          goBack,
          scopeType,
          handleOpenActionsModal,
          handleCloseActionsModal,
          indicatorActions,
          actions: formatActionsByODS(actions, !props?.userId) || [],
          showModalActions,
          isCommunity: !props?.userId,
          projectId: scope?.id,
          ...props
        }}
      />
    </div>
  )
}

export default ESMCommunityPlanContainer